module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-sm-6\"> <h3 class=\"text-center\">Update Account Information</h3> <p>Your name and phone number may be updated without re-entering your password.</p> </div> <div class=\"col-sm-6\"> <div id=\"user_info\"></div> </div> </div> <hr> <div class=\"row\"> <div class=\"col-sm-6\"> <h3 class=\"text-center\">Update Password</h3> <p>When you successfully change password, all other website logins on other browsers and devices will be required to log in again with the new password.</p> </div> <div class=\"col-sm-6\"> <div id=\"user_password\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_edit_page.ejs
// module id = 877
// module chunks = 1